<template>
  <dragPanel
    :title="title ? title : '属性'"
    :closePanel="closePanel">
    <div
      class="attributes-panel"
      v-if="attributeData.length">
      <div
        class="attr-type-box"
        v-if="elemType === 'entity'">
        <div class="dialog-label">类型</div>
        <div class="common-select-box">
          <el-select
            class="primary-select"
            size="small"
            :popper-append-to-body="false"
            :value="attrType"
            @change="handleAttrTypeChange">
            <el-option
              v-for="(item, index) in attrTypeList"
              :title="item.paramsType"
              :key="index"
              :label="item.paramsType"
              :value="item.paramsType" />
          </el-select>
        </div>
      </div>
      <div v-if="elemType === 'ShapeElem'">
        <div class="attr-list-box">
          <div
            v-for="(item, index) in attributeData"
            :key="index"
            class="item-box">
            <div class="label">{{ item.key }}:</div>
            <div
              class="value text-overflow"
              :title="item.value">
              {{ item.value }}
            </div>
          </div>
        </div>
      </div>
      <el-scrollbar
        class="attributes-box"
        v-else>
        <el-collapse
          :value="expandCollapseItems"
          class="el-collapse-primary">
          <el-collapse-item
            :name="index"
            v-for="(item, index) in attributeData"
            :key="index">
            <template slot="title">
              <i class="el-icon-caret-right" />
              <span class="group-name-box">{{ item.paramGroup }}</span>
            </template>
            <div
              class="attributes-content"
              v-for="(val, i) in item.paramDatas"
              :key="i"
              :title="val.paramValue">
              <div class="name-box">{{ val.paramName }}</div>
              <div class="value-box">
                {{ ` ${val.paramValue}${val.paramType}` }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
    </div>
    <div
      v-else
      class="tips">
      <div
        v-if="elemType === 'entity'"
        class="dialog-label">
        <bj-empty class="empty-page">
          <template>
            <span class="empty-text">当前构件没有属性信息</span>
          </template>
        </bj-empty>
      </div>
      <div
        v-else
        class="dialog-label">
        <bj-empty class="empty-page">
          <template>
            <div v-if="isElemExist">
              <!-- prettier-ignore -->
              <span class="empty-text">
                当前选中构件，没有{{isRvtGroupMode ? 'Group' : '' }}属性信息
              </span>
            </div>
            <div v-else>
              <!-- prettier-ignore -->
              <span class="empty-text">
                请选择一个构件，以查看对应{{isRvtGroupMode ? 'Group' : '' }}属性信息
              </span>
            </div>
          </template>
        </bj-empty>
      </div>
    </div>
  </dragPanel>
</template>

<script>
import dragPanel from '@/components/CustomDragPanel.vue'

export default {
  data() {
    return {
      expandCollapseItems: []
    }
  },
  props: {
    title: String,
    isRvtGroupMode: Boolean,
    isElemExist: Boolean,
    attributeData: Array,
    elemType: String,
    attrType: String,
    attrTypeList: Array,
    updateElementAttr: Function,
    closePanel: Function
  },
  components: {
    dragPanel
  },
  watch: {
    attributeData(newVal) {
      if (newVal.length) {
        this.expandCollapseItems = []
        this.attributeData.forEach((item, index) => {
          this.expandCollapseItems.push(index)
        })
      }
    }
  },
  methods: {
    handleAttrTypeChange(attrType) {
      this.updateElementAttr(attrType)
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.common-drag-panel {
  top: 150px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);

  /deep/ .content {
    height: calc(100% - 40px);

    .attributes-panel {
      height: 100%;
      overflow: hidden;

      .attr-type-box {
        display: flex;
        justify-content: space-between;
        padding: 5px 15px;
        line-height: 32px;

        .common-select-box {
          width: 150px;
          text-align: left;
        }
      }

      :deep(.el-collapse) {
        .el-collapse-item:last-child {
          .attributes-content:last-child {
            border-bottom: 1px solid var(--attr-border-color);
          }
        }
      }

      .attributes-box {
        height: calc(100% - 30px);

        .attributes-content {
          display: grid;
          grid-template-columns: 1fr 2fr;
          text-align: left;
          background: transparent;
          border: 1px solid var(--attr-border-color);
          border-bottom: none;

          .name-box {
            padding: 3px 4px 4px 26px;
            color: var(--collapse-text-label-color);
            border-right: 1px solid var(--attr-border-color);
            word-break: break-all;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
          }

          .value-box {
            padding: 4px 4px 4px 8px;
            color: var(--collapse-text-value-color);
            word-break: break-all;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
          }
        }

        .el-collapse-item:last-child {
          border-bottom: 1px solid var(--attr-border-color);
        }
      }

      .el-scrollbar__wrap {
        overflow-x: hidden;
        // overflow-y: auto;
      }

      .el-collapse-primary {
        padding: 15px;

        .group-name-box {
          margin-left: 4px;
          word-break: break-all;
        }

        .el-collapse-item__header {
          height: auto;
          line-height: normal;
          align-items: flex-start;
          text-align: left;

          .el-icon-caret-right {
            margin-top: 4px;
          }
        }
      }
    }

    .attr-list-box {
      padding: 20px;
      height: calc(100% - 20px);
      overflow-y: auto;

      .item-box {
        display: flex;
        margin: 5px 0px;

        .label {
          flex-shrink: 0;
        }

        .value {
          margin-left: 5px;
        }
      }
    }

    .tips {
      font-size: 12px;
      text-align: center;
      color: var(--base-bg-dark-color9);
      height: 100%;
      .dialog-label {
        height: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
      }
    }
  }
}
</style>
